import Repository from '../axios';
const  resource = "/landlord";

export default {
    getLoginPageSettings(){
        return Repository.get(`${resource}/login-page-settings`)
    },
    getTenantLoginPageSettings(id){
        return Repository.get(`${resource}/${id}/login-page-settings`)
    },
    updateLoginPageSettings(payload){
        return Repository.post(`${resource}/login-page-settings`, payload)
    },
    updateTenantLoginPageSetting(id,payload){
        return Repository.post(`${resource}/${id}/login-page-settings`, payload)
    }
}